import type { SVGProps } from 'react'
const SvgSyXrp = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="M850.9 0h143.5L695.8 359.6c-108.1 130.2-283.4 130.2-391.6 0L5.5 0h143.6l226.8 273.2c68.8 82.5 179.2 82.5 248 0zM147.3 1000H3.7l300.5-361.8c108.1-130.2 283.4-130.2 391.6 0L996.3 1000H852.8L624.1 724.6c-68.8-82.5-179.2-82.5-248 0z" />
	</svg>
)
export default SvgSyXrp
